import * as React from "react";
import {
  ToastsContainer,
  ToastsContainerPosition,
  ToastsStore
} from "react-toasts";
import { callApi } from "../../utils/api";
import { Branch } from "../branch/ManageBranch";
import Select from "react-select";
interface AllProps {
  history: any;
  match: any;
}
class AddUser extends React.Component<AllProps> {
  state = {
    errorteamType: false,
    errorFind: false,
    userdetail: {
      teamType: "",
      roleType: "",
      livetracking: "",
      designation: "",
      id: 0,
      name: "",
      employeeId: "",
      email: "",
      mob_no: "",
      branch: "",
      role: "",
      report_to: "",
      password: "",
      confirmpassword: "",
      mybranch: "",
      deviceIdLimit: "1",
      shift_start_time: "", // e.g., "09:00"
      shift_end_time: "",   // e.g., "18:00"
      shiftType: '',
    },
    shiftList: [],
    items: [],
    branches: [],
    role: [],
    reporters: [],
    selectedBranchIds: [] as number[],
    formFields: {
      selectedBranchId: [] as number[],
    },
  };

  componentDidMount() {
    this.listBranches();
    this.getUserDetails();
    this.listReporters();
    this.listRole();
    this.getShiftList();
  }

  getShiftList = () => {
    callApi("GET", "getShifts.php")
      .then(res => res.data)
      .then(response => {
        if (response.result
        ) {
          const files = response.data;
          this.setState({ shiftList: files });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  listBranches = () => {
    callApi("GET", "get_branch.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ branches: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  listRole = () => {
    callApi("GET", "get_role.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ role: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  listReporters = () => {
    callApi("GET", "report_to.php")
      .then(res => res.data)
      .then(response => {
        this.setState({ reporters: response.data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  getUserDetails = () => {
    callApi("POST", "get_user_single.php", { id: this.props.match.params.id })
      .then(res => res.data)
      .then(response => {
        if (response && response.data && response.data.length) {
          const user = response.data[0];
          const selectedBranchId = user.my_branchs.split(',').map(id => id.trim());
          if (response.data[0].password) {
            response.data[0].confirmpassword = response.data[0].password;
          }
          this.setState({
            userdetail: {
              ...user,
            },
            items: user.items || [],
            formFields: {
              ...this.state.formFields,
              selectedBranchId
            }
          });
        }
      });
  };

  handleChange = (e: any) => {
    const userdetail: any = this.state.userdetail;
    const prevValue = userdetail.deviceIdLimit;
    const newValue = e.target.value;

    if (e.target.name === "deviceIdLimit") {
      if (parseInt(newValue) > parseInt(prevValue)) {
        const confirmIncrease = window.confirm("Are you sure you want to increase the device limit?");
        if (!confirmIncrease) return;
      } else if (parseInt(newValue) < parseInt(prevValue)) {
        const confirmDecrease = window.confirm("Are you sure you want to decrease the device limit?");
        if (!confirmDecrease) return;
      }
    }

    userdetail[e.target.name] = newValue;
    this.setState({ userdetail });
  };

  saveUser = (e) => {
    e.preventDefault();
    this.props.match.params.id = Number(this.props.match.params.id);
    const { userdetail } = this.state;

    const payload = {
      ...userdetail,
      selectedBranchId: this.state.formFields.selectedBranchId,
    };

    if (this.props.match.params.id) {
      delete this.state.userdetail.password;
      delete this.state.userdetail.confirmpassword;
      callApi("POST", "user_update.php", payload)
        .then(res => res.data)
        .then(response => {
          if (response.result) {
            this.props.history.push("/user");
          } else {
            ToastsStore.error(response.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      if (this.state.userdetail.roleType == "1" || this.state.userdetail.roleType == "12" || this.state.userdetail.roleType == "2" || this.state.userdetail.roleType == "4" || this.state.userdetail.roleType == "3") {
        if (
          this.state.userdetail.password !== this.state.userdetail.confirmpassword
        ) {
          ToastsStore.error("Password mismatch!");
        } else {
          callApi("POST", "user_create.php", payload)
            .then(res => res.data)
            .then(response => {
              this.props.history.push("/user");
            })
            .catch(err => {
              console.log(err);
            });
        }
      } else if (this.state.userdetail.roleType == "7") {
        if (this.state.userdetail.teamType == "") {
          this.setState({ errorteamType: true });
        } else if (this.state.userdetail.report_to == "") {
          this.setState({ errorteamType: false });
          this.setState({ errorFind: true });
        } else {
          if (
            this.state.userdetail.password !== this.state.userdetail.confirmpassword
          ) {
            ToastsStore.error("Password mismatch!");
          } else {
            callApi("POST", "user_create.php", payload)
              .then(res => res.data)
              .then(response => {
                this.props.history.push("/user");
              })
              .catch(err => {
                console.log(err);
              });
          }
        }
      } else if (this.state.userdetail.roleType == "8" || this.state.userdetail.roleType == "9" || this.state.userdetail.roleType == "10" || this.state.userdetail.roleType == "11") {
        if (this.state.userdetail.report_to == "") {
          this.setState({ errorFind: true });
        } else {
          if (
            this.state.userdetail.password !== this.state.userdetail.confirmpassword
          ) {
            ToastsStore.error("Password mismatch!");
          } else {
            callApi("POST", "user_create.php", payload)
              .then(res => res.data)
              .then(response => {
                this.props.history.push("/user");
              })
              .catch(err => {
                console.log(err);
              });
          }
        }
      }
      else {
        if (
          this.state.userdetail.password !== this.state.userdetail.confirmpassword
        ) {
          ToastsStore.error("Password mismatch!");
        } else {
          callApi("POST", "user_create.php", payload)
            .then(res => res.data)
            .then(response => {
              this.props.history.push("/user");
            })
            .catch(err => {
              console.log(err);
            });
        }
      }
    }
  };

  handleBranchChange = (selectedOptions: any) => {
    if (!selectedOptions) {
      this.setState({
        formFields: {
          ...this.state.formFields,
          selectedBranchId: []
        }
      });
      return;
    }

    const isSelectAll = selectedOptions.some((opt: any) => opt.value === 'all');
    const allBranchIds = this.state.branches.map((branch: any) => branch.id);

    if (isSelectAll) {
      this.setState({
        formFields: {
          ...this.state.formFields,
          selectedBranchId: allBranchIds
        }
      });
    } else {
      const selectedIds = selectedOptions.map((opt: any) => opt.value);
      this.setState({
        formFields: {
          ...this.state.formFields,
          selectedBranchId: selectedIds
        }
      });
    }
  };

  resetDevice = (item: any, e: any) => {
    e.preventDefault();
    callApi("POST", "deviceReset.php", { id: item.id })
      .then(res => res.data)
      .then(response => {
        this.getUserDetails();
        ToastsStore.success(response.message);
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    const { branches, formFields, userdetail } = this.state;
    const baseOptions = branches.map((opt: any) => ({
      label: opt.name,
      value: opt.id
    }));

    const hasAllSelected = formFields.selectedBranchId.length === branches.length;

    const options = [
      { label: 'Select All', value: 'all' },
      ...baseOptions
    ];

    const selectedValues = hasAllSelected
      ? [...baseOptions]
      : formFields.selectedBranchId
        .map(id => baseOptions.find(opt => opt.value === id))
        .filter(Boolean);

    return (
      <div className="pcoded-main-container">
        <ToastsContainer
          store={ToastsStore}
          position={ToastsContainerPosition.TOP_RIGHT}
        />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h5>User Form</h5>
                          <button
                            className="btn btn-primary"
                            style={{ float: "right" }}
                            onClick={() => this.props.history.goBack()}
                          >
                            Back
                          </button>
                        </div>
                        <div className="card-body">
                          <form className="row">
                            {/* Existing Fields */}
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Full Name"
                                  onChange={e => this.handleChange(e)}
                                  name="name"
                                  value={userdetail.name}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Employee ID</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Employee Id"
                                  onChange={e => this.handleChange(e)}
                                  name="employeeId"
                                  value={userdetail.employeeId}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Mobile Number</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Contact"
                                  name="mob_no"
                                  onChange={e => this.handleChange(e)}
                                  value={userdetail.mob_no}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Email address</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter email"
                                  name="email"
                                  required
                                  onChange={e => this.handleChange(e)}
                                  value={userdetail.email}
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Branch</label>
                                <select
                                  className="custom-select"
                                  name="branch"
                                  value={userdetail.branch}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select the Branch</option>
                                  {branches.map((itm: Branch) => (
                                    <option key={itm.id} value={itm.id}>
                                      {itm.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            {this.props.match.params.id === "0" && (
                              <>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Password</label>
                                    <input
                                      type="password"
                                      className="form-control"
                                      placeholder="Enter Password"
                                      name="password"
                                      onChange={e => this.handleChange(e)}
                                      value={userdetail.password}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label>Confirm Password</label>
                                    <input
                                      type="password"
                                      className="form-control"
                                      placeholder="Re-enter Password"
                                      name="confirmpassword"
                                      onChange={e => this.handleChange(e)}
                                      value={userdetail.confirmpassword}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Role Type</label>
                                <select
                                  className="custom-select"
                                  name="roleType"
                                  value={userdetail.roleType}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select the Role</option>
                                  {this.state.role.map((itm: any) => (
                                    <option key={itm.role_id} value={itm.role_id}>
                                      {itm.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Live Tracking Role</label>
                                <select
                                  className="custom-select"
                                  name="livetracking"
                                  value={userdetail.livetracking}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select the Role</option>
                                  {this.state.role.map((itm: any) => (
                                    <option key={itm.role_id} value={itm.role_id}>
                                      {itm.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Designation</label>
                                <select
                                  className="custom-select"
                                  name="designation"
                                  value={userdetail.designation}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select the Designation</option>
                                  {this.state.role.map((itm: any) => (
                                    <option key={itm.role_id} value={itm.role_id}>
                                      {itm.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Select The Team (Process Team)</label>
                                <select
                                  className="custom-select"
                                  name="teamType"
                                  value={userdetail.teamType}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select One</option>
                                  <option value="1">Alpha Team</option>
                                  <option value="2">Bravo Team</option>
                                  <option value="3">Cobra Team</option>
                                  <option value="4">Delta Team</option>
                                </select>
                                {this.state.errorteamType && (
                                  <p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>
                                    Please Select Your Type
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Team Leader</label>
                                <select
                                  className="custom-select"
                                  name="report_to"
                                  value={userdetail.report_to}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select</option>
                                  {this.state.reporters.map((report: any, index: number) => (
                                    <option key={index} value={report.id}>
                                      {report.name}
                                    </option>
                                  ))}
                                </select>
                                {this.state.errorFind && (
                                  <p style={{ color: "red", textAlign: "center", fontSize: "16px" }}>
                                    Please Select Your Type
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>My Branch</label>
                                {branches.length > 0 && (
                                  <Select
                                    options={options}
                                    name="mybranch"
                                    closeMenuOnSelect={false}
                                    isMulti
                                    value={selectedValues}
                                    onChange={this.handleBranchChange}
                                  />
                                )}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Select the Device Limit</label>
                                <select
                                  className="custom-select"
                                  name="deviceIdLimit"
                                  value={userdetail.deviceIdLimit}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="1">1</option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                </select>
                              </div>
                            </div>

                            {/* Shift Time Fields */}
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Shift Type</label>
                                <select
                                  className="custom-select"
                                  name="shiftType"
                                  value={userdetail.shiftType}
                                  onChange={e => this.handleChange(e)}
                                >
                                  <option value="">Select the Shift</option>
                                  {this.state.shiftList.map((itm: any) => (
                                    <option key={itm.id} value={itm.id}>
                                      {itm.shiftName}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                style={{ marginTop: "27px" }}
                                onClick={e => this.saveUser(e)}
                              >
                                Submit
                              </button>
                            </div>
                          </form>

                          {/* Devices Table */}
                          {this.state.items.length > 0 && (
                            <div className="row">
                              <div className="col-md-12">
                                <div className="mt-4">
                                  <h5>Devices</h5>
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Device ID</th>
                                        <th>Browser</th>
                                        <th>Login Time</th>
                                        <th>Login Location</th>
                                        <th>Logout Time</th>
                                        <th>Logout Location</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.items.map((item: any, index) => (
                                        <tr key={index} className="boxnone" style={{ boxShadow: "none !important" }}>
                                          <td><p>{item.deviceId}</p></td>
                                          <td><p>{item.browser}</p></td>
                                          <td><p>{item.loginTime}</p></td>
                                          <td>
                                            <p>
                                              <a
                                                href={`https://www.google.com/maps?q=${item.loginLat},${item.loginLong}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {item.loginLat} - {item.loginLong}
                                              </a>
                                            </p>
                                          </td>
                                          <td><p>{item.logoutTime}</p></td>
                                          <td>
                                            <p>
                                              <a
                                                href={`https://www.google.com/maps?q=${item.logoutLat},${item.logoutLong}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                {item.logoutLat} - {item.logoutLong}
                                              </a>
                                            </p>
                                          </td>
                                          <td>
                                            <button
                                              className="btn btn-danger"
                                              type="submit"
                                              onClick={e => this.resetDevice(item, e)}
                                            >
                                              Reset
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddUser;